import { mapObjectKeysToValues } from '../../utils/core/object';

export const CONTROL_STATUSES = {
    PUBLISHED: 'Published',
    DRAFT: 'Draft',
} as const;

export const CONTROL_STATUSES_KEYS = mapObjectKeysToValues(CONTROL_STATUSES);

export const CONTROL_TYPES = {
    MANUAL: 'Manual',
    AUTOMATED: 'Automated',
} as const;

export const CONTROL_FREQUENCY = {
    ANNUAL: 'Annual',
    AD_HOC: 'Ad-hoc',
    EVERY_6_MONTHS: 'Every 6 months',
    EVERY_3_MONTHS: 'Every 3 months',
    MONTHLY: 'Monthly',
    FORTNIGHTLY: 'Fortnightly',
    WEEKLY: 'Weekly',
    DAILY: 'Daily',
    MULTIPLE_TIMES_A_DAY: 'Multiple times a day',
} as const;

export const CONTROL_TEST_OUTCOMES = {
    PASS: 'Pass',
    FAIL: 'Fail',
} as const;

export const CONTROL_TEST_OUTCOMES_KEYS = mapObjectKeysToValues(CONTROL_TEST_OUTCOMES);

export const CONTROL_TEST_FREQUENCY = {
    ANNUAL: 'Annual',
    AD_HOC: 'Ad-hoc',
    EVERY_6_MONTHS: 'Every 6 months',
    EVERY_3_MONTHS: 'Every 3 months',
    MONTHLY: 'Monthly',
    FORTNIGHTLY: 'Fortnightly',
    WEEKLY: 'Weekly',
    DAILY: 'Daily',
    MULTIPLE_TIMES_A_DAY: 'Multiple times a day',
} as const;

export const CONTROL_ACTIVITY_RATING = {
    EFFECTIVE: 'Effective',
    NEEDS_IMPROVEMENT: 'Needs improvement',
    NOT_EFFECTIVE: 'Not effective',
} as const;

export type ControlStatus = keyof typeof CONTROL_STATUSES;
export type ControlType = keyof typeof CONTROL_TYPES;
export type ControlFrequency = keyof typeof CONTROL_FREQUENCY;
export type ControlTestOutcome = keyof typeof CONTROL_TEST_OUTCOMES;
export type ControlTestFrequency = keyof typeof CONTROL_TEST_FREQUENCY;
export type ControlActivityRating = keyof typeof CONTROL_ACTIVITY_RATING;
